/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpcomingClassRow } from './UpcomingClassRow';
import {
    UpcomingClassRowFromJSON,
    UpcomingClassRowFromJSONTyped,
    UpcomingClassRowToJSON,
    UpcomingClassRowToJSONTyped,
} from './UpcomingClassRow';

/**
 * 
 * @export
 * @interface UpcomingClassesWidgetData
 */
export interface UpcomingClassesWidgetData {
    /**
     * 
     * @type {Array<UpcomingClassRow>}
     * @memberof UpcomingClassesWidgetData
     */
    items: Array<UpcomingClassRow>;
}

/**
 * Check if a given object implements the UpcomingClassesWidgetData interface.
 */
export function instanceOfUpcomingClassesWidgetData(value: object): value is UpcomingClassesWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function UpcomingClassesWidgetDataFromJSON(json: any): UpcomingClassesWidgetData {
    return UpcomingClassesWidgetDataFromJSONTyped(json, false);
}

export function UpcomingClassesWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpcomingClassesWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UpcomingClassRowFromJSON)),
    };
}

export function UpcomingClassesWidgetDataToJSON(json: any): UpcomingClassesWidgetData {
    return UpcomingClassesWidgetDataToJSONTyped(json, false);
}

export function UpcomingClassesWidgetDataToJSONTyped(value?: UpcomingClassesWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(UpcomingClassRowToJSON)),
    };
}

